module.exports = __webpack_public_path__ + "img/cash_nl1000.85c267a5.png";